module.exports = new __parcel__URL__("thickskin.4eb9f76c.png").toString();